import { ThemeProvider } from "@emotion/react";
import {
  Box,
  BoxProps,
  createTheme,
  FormLabel,
  FormLabelProps,
} from "@mui/material";
import { STheme } from "components/styles";

export type SLabelProps = Pick<FormLabelProps, "children" | "required"> &
  Partial<Pick<BoxProps, "gridColumn" | "gridRow">>;

export const SLabel = ({ gridColumn, gridRow, ...props }: SLabelProps) => (
  <ThemeProvider theme={theme}>
    <Box display="grid" gridColumn={gridColumn} gridRow={gridRow}>
      <FormLabel {...props}>{props.children}</FormLabel>
    </Box>
  </ThemeProvider>
);

const theme = createTheme(
  {
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: "0.9rem",
            borderStyle: "solid",
            borderWidth: "1px",
            paddingLeft: "4px",
            paddingTop: "1px",
            paddingBottom: "0px",
            display: "flex",
            alignItems: "center",
            color: STheme.labels.text,
            backgroundColor: STheme.labels.normal,
            borderColor: STheme.labels.border,
          },
          asterisk: {
            fontSize: "1.3rem",
            color: STheme.labels.required,
          },
        },
      },
    },
  },
  { ...STheme }
);
